import { CONTEXT } from "./CONTEXT";

export const CUSTOM_CONTEXT_STORAGE_KEY = "chatCustomContext";

// Returns the context edited from the GUI (stored in localStorage) or null
// when none has been saved.
export const getCustomContext = () => {
  try {
    return localStorage.getItem(CUSTOM_CONTEXT_STORAGE_KEY);
  } catch (error) {
    return null;
  }
};

export const setCustomContext = (context) => {
  localStorage.setItem(CUSTOM_CONTEXT_STORAGE_KEY, context);
};

export const clearCustomContext = () => {
  localStorage.removeItem(CUSTOM_CONTEXT_STORAGE_KEY);
};

// Returns the context to inject in the chat messages: the custom one when
// present, the default one otherwise.
export const getActiveContext = () => getCustomContext() ?? CONTEXT;
